import {request,newVue, requestMsg} from "./request";
export {newVue}

export function audit(reflectRecord) {
    return requestMsg({
        url: '/divideCommission/audit',
        data: JSON.stringify(reflectRecord),
        method: "POST",
        headers : {"Content-Type" : "application/json;charset=utf-8"}
    })
}

export function getReflectRecordBySearch(status,pageNum,pageSize) {
    return request({
        url: '/divideCommission/getReflectRecordList',
        params: {
            status: status,
            pageNum: pageNum,
            pageSize: pageSize
        }
    })
}